module.exports = __webpack_public_path__ + "static/media/man-queue-small.95142739.jpg";